module.exports = __webpack_public_path__ + "static/media/sp23.dc2417d2.JPG";